import React from 'react';
import {AsyncComponent} from "../../../core/components/router/async-component";
import {StatsWidgetPlaceholder} from "./placeholders/stats.widget.placeholder";
import {ErrorBoundaryWrapper} from "../../../core/components/error-boundary/error-boundary-wrapper";

const StatsWidgetAsyncComponent = AsyncComponent(async () => import('./game-stats-widget' /* webpackChunkName: "game-stats-widget" */ ));

export const GameStatsWidgetAsync = (props) => {
  return <ErrorBoundaryWrapper isMandatory={props.isFullView}>
    <React.Suspense fallback={<StatsWidgetPlaceholder/>}>
      <StatsWidgetAsyncComponent {...props}/>
    </React.Suspense>
  </ErrorBoundaryWrapper>
}
